export const yupSync = (schema: any) => {
  return {
    async validator({ field }: any, value: any) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };
};

export const REGEX = {
  username: /^(?:\+84|0)\d{9,10}$|^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // email || sdt
  // /^(?:\+84|0)\d{9,10}$|^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^\w{6,}$/,  // email || sdt || username
  password: /^.{6,64}$/,
};
